import React, { useEffect, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ChevronLeft as ChevronLeftIcon } from "../icons";
import { ChevronRight as ChevronRightIcon } from "../icons";

// Carrusel liviano para tarjetas de publicaciones (autos/viajes): avanza solo
// entre las fotos de UN mismo aviso, con flechas y puntos para navegar a mano.
// Se pausa al pasar el mouse para no competir con el usuario mientras mira.
const ListingImageSlideshow = ({
  images,
  alt = "",
  height = 200,
  borderRadius = 2,
  autoPlayMs = 4000,
  PlaceholderIcon,
  placeholderText,
}) => {
  const list = Array.isArray(images) ? images.filter(Boolean) : [];
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const hasMultiple = list.length > 1;

  useEffect(() => {
    if (!hasMultiple || paused) return;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % list.length);
    }, autoPlayMs);
    return () => clearInterval(id);
  }, [hasMultiple, paused, list.length, autoPlayMs]);

  const goTo = (e, newIndex) => {
    e.stopPropagation();
    setIndex((newIndex + list.length) % list.length);
  };

  return (
    <Box
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      sx={{
        position: "relative",
        width: "100%",
        height,
        borderRadius,
        overflow: "hidden",
        bgcolor: "action.hover",
      }}
    >
      {list.length === 0 ? (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            color: "text.disabled",
          }}
        >
          {PlaceholderIcon && <PlaceholderIcon sx={{ fontSize: 36 }} />}
          {placeholderText && <Typography sx={{ fontSize: 12 }}>{placeholderText}</Typography>}
        </Box>
      ) : (
        list.map((src, i) => (
          <Box
            key={src + i}
            component="img"
            src={src}
            alt={alt}
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: i === index ? 1 : 0,
              transition: "opacity 0.6s ease",
              // Sin esto, mientras la foto todavía está bajando (sobre todo en
              // conexiones lentas o en el WebView de Android) el <img> pinta
              // blanco por default, tapando el fondo oscuro del contenedor.
              backgroundColor: "rgba(255,255,255,0.05)",
            }}
          />
        ))
      )}

      {hasMultiple && (
        <>
          <IconButton
            size="small"
            onClick={(e) => goTo(e, index - 1)}
            sx={{
              position: "absolute",
              left: 4,
              top: "50%",
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.4)",
              color: "white",
              "&:hover": { bgcolor: "rgba(0,0,0,0.6)" },
            }}
          >
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={(e) => goTo(e, index + 1)}
            sx={{
              position: "absolute",
              right: 4,
              top: "50%",
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.4)",
              color: "white",
              "&:hover": { bgcolor: "rgba(0,0,0,0.6)" },
            }}
          >
            <ChevronRightIcon fontSize="small" />
          </IconButton>
          <Box sx={{ position: "absolute", bottom: 8, left: 0, right: 0, display: "flex", justifyContent: "center", gap: 0.5 }}>
            {list.map((_, i) => (
              <Box
                key={i}
                onClick={(e) => goTo(e, i)}
                sx={{
                  width: i === index ? 16 : 6,
                  height: 6,
                  borderRadius: 3,
                  bgcolor: i === index ? "white" : "rgba(255,255,255,0.5)",
                  transition: "width 0.3s ease",
                  cursor: "pointer",
                }}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default ListingImageSlideshow;
